import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import analyticsPage from '../analyticsPage';

/**
 * Tabs presentational component
 * Renders content within configurable tables
 */
export default function Tabs({ tabs, tab, onChange }) {
    return (
        <div className="search-tabsContainer">
            <div className="search-tabsHeader">
                <div className="ui-tabs">
                    {Object.keys(tabs).map((key) => {
                        const { header, headerProps } = tabs[key];
                        return (
                            <div
                                key={key}
                                className={classnames(
                                    'search-tabs__tab ui-tabs__tab ui-tabs__tab_min',
                                    { 'ui-tabs__tab_selected': key === tab },
                                )}
                                {...headerProps}
                            >
                                <a
                                    className="search-tabs__link"
                                    href={`#${key}`}
                                    onClick={(ev) => {
                                        ev.preventDefault();
                                        onChange(key);
                                        analyticsPage();
                                    }}
                                >
                                    <span className="ui-tabs__label">{header}</span>
                                </a>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="search-tabContent">
                {tabs[tab].content}
            </div>
        </div>
    );
}

Tabs.propTypes = {
    /**
     * List of tabs objects
     */
    tabs: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    /**
     * Active tab
     */
    tab: PropTypes.string.isRequired,
    /**
     * Tab change action
     */
    onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/Common/Tabs.jsx